import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
  fill: "#4848FF"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.51242 8.81753C7.8041 8.50113 8.17918 8.2734 8.60601 8.16162C9.28151 7.98501 9.98696 8.12462 10.5838 8.54158C11.168 8.95952 11.6023 9.61664 11.8134 10.3904L11.8392 10.5001C12.0179 11.2391 11.9635 11.9756 11.6836 12.5931C11.3818 13.2537 10.8394 13.7136 10.1639 13.8903C9.62942 14.0311 9.07432 13.9708 8.57213 13.7285L9.03535 15.8851L9.05466 15.9664L8.97609 15.989L6.98644 16.5036L6.90787 16.5262L6.88049 16.4498L4.56321 9.39839L4.53516 9.31369L4.62214 9.29039L7.36618 8.58067L7.45316 8.55736L7.47314 8.64683L7.51242 8.81753ZM7.85581 11.4261C7.99467 11.9366 8.48893 12.2374 8.93645 12.1199C9.38398 12.0024 9.66095 11.5051 9.52209 10.9946C9.38322 10.4841 8.88897 10.1833 8.44144 10.3008C7.99391 10.4184 7.71694 10.9156 7.85581 11.4261Z",
  fill: "white"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.664 9.17001C18.1999 8.60503 17.5587 8.2916 16.8541 8.28748C16.4111 8.28748 15.9892 8.4112 15.6179 8.64627L15.6264 8.46894V8.37821H15.5378L12.6942 8.36996H12.6014L12.6056 8.46069L12.8418 13.2569C13.4452 13.5703 13.8628 14.1848 13.8628 14.8982C13.8628 15.3642 13.6814 15.7849 13.3903 16.1107H15.1834V16.0282L15.3268 13.6693C15.7487 14.0322 16.2676 14.2301 16.8246 14.2301C17.5249 14.2301 18.1704 13.9208 18.6387 13.36C19.0733 12.8362 19.3264 12.1352 19.3475 11.3722V11.2609C19.3475 10.4567 19.1028 9.71026 18.6514 9.15764L18.664 9.17001ZM16.1242 12.2053C15.6559 12.2053 15.2593 11.7887 15.2635 11.2609C15.2635 10.7289 15.6643 10.3206 16.1326 10.3206C16.6009 10.3206 16.9975 10.7371 16.9933 11.265C16.9933 11.797 16.5925 12.2053 16.1242 12.2053Z",
  fill: "white"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M11.9686 16.02C12.6015 16.02 13.1162 15.5169 13.1162 14.8983C13.1162 14.2797 12.6015 13.7765 11.9686 13.7765C11.3358 13.7765 10.8211 14.2797 10.8211 14.8983C10.8211 15.5169 11.3358 16.02 11.9686 16.02Z",
  fill: "white"
}, null, -1);
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_5);
}
const icV2StovePpoolAppColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2StovePpoolAppColor as default
};
